






































































































































import {Component, Prop, Vue} from 'vue-property-decorator'
import * as _ from 'lodash';

import {DxCheckBox} from "devextreme-vue/check-box";
import UserAccessService from '@/services/user_access_service';
import { formatNumber, formatCurrency } from '@/utils/number-formatter';
import {getImbalanceStyleColor} from "@/utils/getImbalanceStyleColor";
import NumberSpan from '@/components/InputComponents/number-span.vue';

// Интерфейс для филиала/узла
interface IFilialOrNode {
  name: string;
  imbalance: boolean;
  accept: boolean;
  months: {
    [month: string]: {
      water: number;
      steam: number;
    }
  };
}

export class UserAccessAggSchema  {
  id_heat_node: string | number | null = null;
  filial: string | null = null;
  heat_node_name: string | null = null;
  permissions: any = null;
}

@Component({
  name: 'ControlGrid',
  components: {
    DxCheckBox,
    NumberSpan
  }
})
export default class extends Vue {

  @Prop() public dataSource: any;
  // todo заменить на запрос роли
  @Prop({default: true}) public isAdmin!: boolean;

  public service = UserAccessService;

  public group_selected: any = {};

  public columns_top: any[] = [
    {
      dataField: 'Object',
      caption: 'Наименование',
      rowspan: '2',
    },
    {
      dataField: 'total',
      caption: 'Сетевая вода + Пар',
      colspan: '12',
    },
    {
      dataField: 'water',
      caption: 'Сетевая вода',
      colspan: '12'
    },
    {
      dataField: 'steam',
      caption: 'Пар',
      colspan: '12'
    },
  ];

  public columns_low: any[] = [
    { dataField: 'total__1', caption: 'Янв' },
    { dataField: 'total__2', caption: 'Фев' },
    { dataField: 'total__3', caption: 'Мар' },
    { dataField: 'total__4', caption: 'Апр' },
    { dataField: 'total__5', caption: 'Май' },
    { dataField: 'total__6', caption: 'Июн' },
    { dataField: 'total__7', caption: 'Июл' },
    { dataField: 'total__8', caption: 'Авг' },
    { dataField: 'total__9', caption: 'Сен' },
    { dataField: 'total__10', caption: 'Окт' },
    { dataField: 'total__11', caption: 'Ноя' },
    { dataField: 'total__12', caption: 'Дек' },
    { dataField: 'water__1', caption: 'Янв' },
    { dataField: 'water__2', caption: 'Фев' },
    { dataField: 'water__3', caption: 'Мар' },
    { dataField: 'water__4', caption: 'Апр' },
    { dataField: 'water__5', caption: 'Май' },
    { dataField: 'water__6', caption: 'Июн' },
    { dataField: 'water__7', caption: 'Июл' },
    { dataField: 'water__8', caption: 'Авг' },
    { dataField: 'water__9', caption: 'Сен' },
    { dataField: 'water__10', caption: 'Окт' },
    { dataField: 'water__11', caption: 'Ноя' },
    { dataField: 'water__12', caption: 'Дек' },
    { dataField: 'steam__1', caption: 'Янв' },
    { dataField: 'steam__2', caption: 'Фев' },
    { dataField: 'steam__3', caption: 'Мар' },
    { dataField: 'steam__4', caption: 'Апр' },
    { dataField: 'steam__5', caption: 'Май' },
    { dataField: 'steam__6', caption: 'Июн' },
    { dataField: 'steam__7', caption: 'Июл' },
    { dataField: 'steam__8', caption: 'Авг' },
    { dataField: 'steam__9', caption: 'Сен' },
    { dataField: 'steam__10', caption: 'Окт' },
    { dataField: 'steam__11', caption: 'Ноя' },
    { dataField: 'steam__12', caption: 'Дек' },
  ];

  public format3Digits = new Intl.NumberFormat('ru-RU', {style: 'decimal', maximumFractionDigits: 3});
  public format3DigitsFraction = new Intl.NumberFormat('ru-RU', {style: 'decimal', minimumFractionDigits: 3, maximumFractionDigits: 3});

  public showHint: boolean = false;

  // Новая логика расчёта небаланса для отображения
  public calculateWaterImbalance(monthData: any[]): number {
    // monthData: массив небалансов по объектам за месяц
    const sum = monthData.reduce((acc, obj) => acc + Math.abs(Number(obj)), 0);
    return Number(sum.toFixed(5));
  }

  public calculateSteamImbalance(monthData: any[]): number {
    // monthData: массив объектов, каждый объект — массив из 5 видов пара
    const sum = monthData.reduce((acc, obj) => {
      if (Array.isArray(obj)) {
        // obj — массив из 5 видов пара
        const objSum = obj.reduce((a, v) => a + Math.abs(Number(v)), 0);
        return acc + objSum;
      } else {
        // если просто число
        return acc + Math.abs(Number(obj));
      }
    }, 0);
    return Number(sum.toFixed(5));
  }

  // Новый вычисляемый массив филиалов
  get filialsList(): Array<{ id: string; data: IFilialOrNode }> {
    if (!this.dataSource || !this.dataSource.filials) return [];
    return Object.entries(this.dataSource.filials).map(([id, data]) => ({ id, data: data as IFilialOrNode }));
  }
  // Новый вычисляемый массив узлов
  get nodesList(): Array<{ id: string; data: IFilialOrNode }> {
    if (!this.dataSource || !this.dataSource.nodes) return [];
    return Object.entries(this.dataSource.nodes).map(([id, data]) => ({ id, data: data as IFilialOrNode }));
  }

  created() {

  }

  isSelectedBlock(val: any) {
    return val === true;
  }

  formatNumber(value: number) {
    return this.$options.filters?.numberFormat(value, 2) || value.toString();
  }

  hightlightImbalance(dataField: string, node: any) {
    let parts = dataField.split('__')
    if(parts[0] === 'total') {
      if(Math.abs(node[parts[1]].steam + node[parts[1]].water) < 0.00005) {
        return 'accept'
      } else return 'imbalance'
    } else {
      if(Math.abs(node[parts[1]][parts[0]]) < 0.00005) {
        return 'accept'
      } else return 'imbalance'
    }

  }

  setColorMonth(dataField: string, node: any, key: string) {
    let parts = dataField.split('__')
    if(parts[0] === 'total') {
      return getImbalanceStyleColor(key, node[parts[1]].steam + node[parts[1]].water);
    } else {
      return getImbalanceStyleColor(key, node[parts[1]][parts[0]]);
    }
  }

  setColorFilialOrNode(data: any, key: string) {
    let total = 0;

    for (const key in data) {
      if (data.hasOwnProperty(key)) {
        const item = data[key];
        const steam = parseFloat(item.steam) || 0;
        const water = parseFloat(item.water) || 0;
        total += steam + water;
      }
    }

    return getImbalanceStyleColor(key, total);
  }

  formatTitle(value: number) {
    if (_.isNil(value)) {
      return '';
    }
    return formatNumber(value);
  }

  formatValue(value: number) {
    if (_.isNil(value)) {
      return '';
    }
    return formatNumber(value);
  }

  /**
   * Возвращает строку для тултипа с итоговым небалансом по всем месяцам (сумма total по месяцам, с сохранением знака, 5 знаков)
   */
  getTotalImbalanceTooltip(months: {[month: string]: {water: number, steam: number}}): string {
    if (!months) return '';
    let sum = 0;
    for (let i = 1; i <= 12; i++) {
      const m = months[i] || months[i.toString()] || months[`${i}`];
      if (m) {
        sum += Number(m.water) + Number(m.steam);
      }
    }
    return `Итоговый небаланс за год: ${sum.toFixed(5)}`;
  }
}
